import LoadingButton from "../../../../components/Loading/LoadingButton";
import usePDFDownload from "../../../../hooks/usePDFDownload";

const DownloadReport = ({ state }) => {
  const { mutate, isPending } = usePDFDownload({
    url: "/totalpost/v1/report",
    method: "GET",
    params: {
      startDate: state.startDate || undefined,
      endDate: state.endDate || undefined,
      numberParcel: state.numberParcel || undefined,
      partnumber: state.partnumber || undefined,
      componyId: state.componyId || undefined,
      status: state.status || undefined,
      weight: state.weight || undefined,
      getterName: state.getterName || undefined,
      getterProvince: state.getterProvince || undefined,
      getterCity: state.getterCity || undefined,
      senderName: state.senderName || undefined,
      senderProvince: state.senderProvince || undefined,
      senderCity: state.senderCity || undefined,
      shipment_list:
        state.selectedValue &&
        Array.isArray(state.selectedValue) &&
        state.selectedValue.length
          ? state.selectedValue.join(",")
          : undefined,
      method_payment: state.method_payment || undefined,
    },
  });

  if (isPending) {
    return (
      <LoadingButton
        className="btn-danger fw-bold px-2 m-2"
        center
        title="در حال دانلود"
      />
    );
  }

  return (
    <button className="btn btn-danger fw-bold" onClick={() => mutate()}>
      دانلود فایل pdf
    </button>
  );
};

export default DownloadReport;
